import { createTheme } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#1d2b28",
    },
    secondary: {
      main: "#1d2b28",
    },
    info: {
      main: "#1d2b28",
    },
    success: {
      main: "#00C9A5",
    },
    error: {
      main: "#1d2b28",
    },
    warning: {
      main: "#F9F871",
    },
  },
});
export default theme;
